import Footer from "../../global/footer";

export default class BlogFooter extends Footer {
	constructor() {
		super();
	}

	init() {
		super.init();
		this.initDarkmodeSwitcher();
	}

	initDynamic() {
		const $urlRu = document.querySelector('.site-header [data-lang-switcher="ru"]');
		const $urlUk = document.querySelector('.site-header [data-lang-switcher="uk"]');

		if ($urlRu) {
			this.urlRu = $urlRu.href;
		}

		if ($urlUk) {
			this.urlUk = $urlUk.href;
		}

		super.initDynamic();
	}

	initDarkmodeSwitcher() {
		const $control = document.getElementById('footerDarkmodeSwitcher');

		if (!$control) return;

		const $input = $control.querySelector('input');
		const cookie = costorage.get('h_darkMode');

		if (cookie && !!+cookie) {
			$input.checked = true;
		} else {
			$input.checked = false;
		}

		$input.addEventListener('change', (e) => {
			if (e.target.checked) {
				document.body.classList.add('-darkmode');
				costorage.set('h_darkMode', '1', { expires: (5 * 24 * 60 * 60), path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
			} else {
				document.body.classList.remove('-darkmode');
				costorage.set('h_darkMode', '0', { expires: (5 * 24 * 60 * 60), path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
			}
		});
	}
}